import Pagination from "rc-pagination";
import React from "react";
import "rc-pagination/assets/index.css";

const CustomPagination = ({ total, pageSize, current, pageChangeHandler }) => {
  if (!total) {
    return <></>;
  }
  return (
    <>
      <div className={`cstmPagination d-inline-flex align-items-center gap-10`}>
        <p className="m-0 fw-sbold text-dark">
          {current * pageSize - pageSize + 1}-{total || 1} of items
        </p>
        <Pagination
          total={total}
          pageSize={pageSize}
          current={current}
          onChange={pageChangeHandler}
        />
      </div>
    </>
  );
};

export default CustomPagination;
